import { Accordion } from 'react-bootstrap';
import { GradingArrowUp } from '../icons/icons';
import './AppAccordion.css';

interface AppAccordionProps {
    headerElement: JSX.Element;
    bodyElement: JSX.Element;
}

export const AppAccordion = ({
    headerElement,
    bodyElement,
}: AppAccordionProps) => {
    return (
        <div className='susy-accordion-box'>
            <Accordion>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header>
                        {headerElement}
                        <div className='susy-accordion-expand-button'>
                            <GradingArrowUp />
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>{bodyElement}</Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};
